var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1104",
    "data-name": "Group 1104",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 15.359,
    height: 26.15,
    viewBox: "0 0 15.359 26.15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1127",
    "data-name": "Rectangle 1127",
    width: 15.359,
    height: 26.15,
    fill: "#434343"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_891",
    "data-name": "Group 891",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2851",
    "data-name": "Path 2851",
    d: "M12.891,26.15H2.468A2.47,2.47,0,0,1,0,23.683V2.467A2.47,2.47,0,0,1,2.468,0H12.89a2.472,2.472,0,0,1,2.469,2.469V23.683a2.47,2.47,0,0,1-2.468,2.467M2.468,1.329A1.14,1.14,0,0,0,1.329,2.467V23.683a1.14,1.14,0,0,0,1.139,1.139H12.891a1.14,1.14,0,0,0,1.139-1.139V2.469a1.142,1.142,0,0,0-1.141-1.14Z",
    fill: "#434343"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2852",
    "data-name": "Path 2852",
    d: "M15.313,50.408a1.612,1.612,0,1,1,1.61-1.613,1.614,1.614,0,0,1-1.61,1.613m0-1.895a.283.283,0,1,0,.282.282.283.283,0,0,0-.282-.282",
    transform: "translate(-7.632 -26.287)",
    fill: "#434343"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2853",
    "data-name": "Path 2853",
    d: "M15.325,22.463H6.186a.665.665,0,0,1-.664-.664V6.756a.664.664,0,0,1,.664-.664h9.138a.664.664,0,0,1,.664.664V21.8a.665.665,0,0,1-.664.664M6.851,21.134h7.81V7.421H6.851Z",
    transform: "translate(-3.076 -3.394)",
    fill: "#434343"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.e32b3495aa8a89958d181011ef88aef3.svg";
export { ForwardRef as ReactComponent };